export default __webpack_public_path__ + "static/media/img7.0dc02071.png";